import {createContext, useCallback, useContext} from "react";
import useApiService from "./ApiService";
import CONFIG from "./CONFIG";

const DictionaryTermApiContext = createContext(null);

export function DictionaryTermApiProvider({ children }) {
    const { get, post, patch, del } = useApiService(CONFIG.SERVER_ASSISTANT);

    const getDictionaryTerms = useCallback(async (dictionaryId, skip, limit) => {
        if (!skip) {
            skip = 0;
        }
        if (!limit) {
            limit = 10;
        }
        try {
            const response = await get(`/v1/taxonomy_dictionary/${dictionaryId}/terms?skip=${skip}&limit=${limit}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching dictionary terms:", error);
            throw error;
        }
    }, [get]);

    const getDictionaryTermById = useCallback(async (dictionaryId, termId) => {
        try {
            const response = await get(`/v1/taxonomy_dictionary/${dictionaryId}/terms/${termId}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching dictionary term by ID:", error);
            throw error;
        }
    }, [get]);

    const createDictionaryTerm = useCallback(async (dictionaryId, data) => {
        try {
            const response = await post(`/v1/taxonomy_dictionary/${dictionaryId}/terms`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating dictionary term:", error);
            throw error;
        }
    }, [post]);

    const updateDictionaryTerm = useCallback(async (dictionaryId, termId, data) => {
        try {
            const response = await patch(`/v1/taxonomy_dictionary/${dictionaryId}/terms/${termId}`, data);
            return response.data;
        } catch (error) {
            console.error("Error updating dictionary term:", error);
            throw error;
        }
    }, [patch]);

    const deleteDictionaryTerm = useCallback(async (dictionaryId, termId) => {
        try {
            const response = await del(`/v1/taxonomy_dictionary/${dictionaryId}/terms/${termId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleting dictionary term:", error);
            throw error;
        }
    }, [del]);

    return (
        <DictionaryTermApiContext.Provider value={{
            getDictionaryTerms,
            getDictionaryTermById,
            createDictionaryTerm,
            updateDictionaryTerm,
            deleteDictionaryTerm
        }}>
            {children}
        </DictionaryTermApiContext.Provider>
    )
}

export function useDictionaryTermApi() {
    const context = useContext(DictionaryTermApiContext);
    if (!context) {
        throw new Error("useDictionaryTermApi must be used within a DictionaryTermApiProvider");
    }
    return context;
}
